import type { Capability } from '@taler/api-client'

/** Every `ImportApi` method requires `RECORDS_MANAGE` server-side (`ImportService.kt`) - the
 * same reasoning as loans, contacts, targets and receipt scans: an import is a financial
 * record, not an accounting view, and the contract grants no dedicated capability to invent a
 * narrower gate. */
export function canManageImports(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE')
}
